/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Mobilefreebies_Title1Inputs */

const id_components_mobilefreebies_title1 = /** @type {(inputs: Components_Mobilefreebies_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game Gratis Seluler`)
};

const ms_components_mobilefreebies_title1 = /** @type {(inputs: Components_Mobilefreebies_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permainan Percuma Mudah Alih`)
};

const da_components_mobilefreebies_title1 = /** @type {(inputs: Components_Mobilefreebies_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobile Gratis Spil`)
};

const de_components_mobilefreebies_title1 = /** @type {(inputs: Components_Mobilefreebies_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobile kostenlose Spiele`)
};

const en_us2_components_mobilefreebies_title1 = /** @type {(inputs: Components_Mobilefreebies_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobile Free Games`)
};

const es_es2_components_mobilefreebies_title1 = /** @type {(inputs: Components_Mobilefreebies_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juegos gratis móviles`)
};

const es_mx2_components_mobilefreebies_title1 = /** @type {(inputs: Components_Mobilefreebies_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juegos gratis móviles`)
};

const fil_components_mobilefreebies_title1 = /** @type {(inputs: Components_Mobilefreebies_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Mobile na Libreng Laro`)
};

const fr_components_mobilefreebies_title1 = /** @type {(inputs: Components_Mobilefreebies_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeux gratuits mobiles`)
};

const it_components_mobilefreebies_title1 = /** @type {(inputs: Components_Mobilefreebies_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giochi gratuiti mobile`)
};

const hu_components_mobilefreebies_title1 = /** @type {(inputs: Components_Mobilefreebies_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobil ingyenes játékok`)
};

const nl_components_mobilefreebies_title1 = /** @type {(inputs: Components_Mobilefreebies_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobiele gratis games`)
};

const no_components_mobilefreebies_title1 = /** @type {(inputs: Components_Mobilefreebies_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobil gratis spill`)
};

const pl_components_mobilefreebies_title1 = /** @type {(inputs: Components_Mobilefreebies_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darmowe gry mobilne`)
};

const pt_br2_components_mobilefreebies_title1 = /** @type {(inputs: Components_Mobilefreebies_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobile Free Games`)
};

const pt_components_mobilefreebies_title1 = /** @type {(inputs: Components_Mobilefreebies_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogos grátis móveis`)
};

const ro_components_mobilefreebies_title1 = /** @type {(inputs: Components_Mobilefreebies_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jocuri gratuite mobile`)
};

const fi_components_mobilefreebies_title1 = /** @type {(inputs: Components_Mobilefreebies_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobiilin ilmaispelit`)
};

const sv_components_mobilefreebies_title1 = /** @type {(inputs: Components_Mobilefreebies_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobil gratisspel`)
};

const vi_components_mobilefreebies_title1 = /** @type {(inputs: Components_Mobilefreebies_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game miễn phí di động`)
};

const tr_components_mobilefreebies_title1 = /** @type {(inputs: Components_Mobilefreebies_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobil Ücretsiz Oyunlar`)
};

const cs_components_mobilefreebies_title1 = /** @type {(inputs: Components_Mobilefreebies_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobilní hry zdarma`)
};

const bg_components_mobilefreebies_title1 = /** @type {(inputs: Components_Mobilefreebies_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мобилни безплатни игри`)
};

const ru_components_mobilefreebies_title1 = /** @type {(inputs: Components_Mobilefreebies_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мобильные бесплатные игры`)
};

const uk_components_mobilefreebies_title1 = /** @type {(inputs: Components_Mobilefreebies_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мобільні безкоштовні ігри`)
};

const ar_components_mobilefreebies_title1 = /** @type {(inputs: Components_Mobilefreebies_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الألعاب المجانية للجوال`)
};

const hi_components_mobilefreebies_title1 = /** @type {(inputs: Components_Mobilefreebies_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मोबाइल मुफ़्त गेम`)
};

const th_components_mobilefreebies_title1 = /** @type {(inputs: Components_Mobilefreebies_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกมฟรีบนมือถือ`)
};

const ja_components_mobilefreebies_title1 = /** @type {(inputs: Components_Mobilefreebies_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`モバイル無料ゲーム`)
};

const zh_cn2_components_mobilefreebies_title1 = /** @type {(inputs: Components_Mobilefreebies_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobile Free Games`)
};

const zh_hant1_components_mobilefreebies_title1 = /** @type {(inputs: Components_Mobilefreebies_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobile Free Games`)
};

const ko_components_mobilefreebies_title1 = /** @type {(inputs: Components_Mobilefreebies_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobile Free Games`)
};

/**
* | output |
* | --- |
* | "Mobile Free Games" |
*
* @param {Components_Mobilefreebies_Title1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_mobilefreebies_title1 = /** @type {((inputs?: Components_Mobilefreebies_Title1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Mobilefreebies_Title1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_mobilefreebies_title1(inputs)
	if (locale === "ms") return ms_components_mobilefreebies_title1(inputs)
	if (locale === "da") return da_components_mobilefreebies_title1(inputs)
	if (locale === "de") return de_components_mobilefreebies_title1(inputs)
	if (locale === "en-US") return en_us2_components_mobilefreebies_title1(inputs)
	if (locale === "es-ES") return es_es2_components_mobilefreebies_title1(inputs)
	if (locale === "es-MX") return es_mx2_components_mobilefreebies_title1(inputs)
	if (locale === "fil") return fil_components_mobilefreebies_title1(inputs)
	if (locale === "fr") return fr_components_mobilefreebies_title1(inputs)
	if (locale === "it") return it_components_mobilefreebies_title1(inputs)
	if (locale === "hu") return hu_components_mobilefreebies_title1(inputs)
	if (locale === "nl") return nl_components_mobilefreebies_title1(inputs)
	if (locale === "no") return no_components_mobilefreebies_title1(inputs)
	if (locale === "pl") return pl_components_mobilefreebies_title1(inputs)
	if (locale === "pt-BR") return pt_br2_components_mobilefreebies_title1(inputs)
	if (locale === "pt") return pt_components_mobilefreebies_title1(inputs)
	if (locale === "ro") return ro_components_mobilefreebies_title1(inputs)
	if (locale === "fi") return fi_components_mobilefreebies_title1(inputs)
	if (locale === "sv") return sv_components_mobilefreebies_title1(inputs)
	if (locale === "vi") return vi_components_mobilefreebies_title1(inputs)
	if (locale === "tr") return tr_components_mobilefreebies_title1(inputs)
	if (locale === "cs") return cs_components_mobilefreebies_title1(inputs)
	if (locale === "bg") return bg_components_mobilefreebies_title1(inputs)
	if (locale === "ru") return ru_components_mobilefreebies_title1(inputs)
	if (locale === "uk") return uk_components_mobilefreebies_title1(inputs)
	if (locale === "ar") return ar_components_mobilefreebies_title1(inputs)
	if (locale === "hi") return hi_components_mobilefreebies_title1(inputs)
	if (locale === "th") return th_components_mobilefreebies_title1(inputs)
	if (locale === "ja") return ja_components_mobilefreebies_title1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_mobilefreebies_title1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_mobilefreebies_title1(inputs)
	return ko_components_mobilefreebies_title1(inputs)
});
export { components_mobilefreebies_title1 as "components.mobileFreebies.title" }